module.exports = __webpack_public_path__ + "media/images/processing-2233bf88ba156c4864ff151e163b7eb7.gif";